import { FC, useEffect, useState } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import { calendarCreate } from 'lowcode/utils/apis/calendarCreate';
import { useRouter } from 'next/router';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const TheComp: FC = () => {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('dp3.teaser');
    const [isShow, setIsShow] = useState(false);
    const [isShow2, setIsShow2] = useState(false);
    const url1 = 'https://www.youtube.com/embed/1ifANYoSi10?si=sLz7uf6Wz8HIVVTY';
    const SOURCE_AU = 'https://www.youtube.com/embed/F7rsXOarw3s?si=gmhPQ1Fd8ADeluds';
    useEffect(() => {
        const ob1 = new IntersectionObserver(
            (elems) => {
                const elem = elems[0];
                if (elem.isIntersecting) {
                    setIsShow(true);
                }
            },
            {
                rootMargin: '-100px', //偏移量,-100px表示从底部伸出100px了
                threshold: 0, //0 - 1;0表示监听元素有部分进入了可视区
            },
        );
        const elemA = document.querySelector('#dp3-teaser-K');
        if (elemA) {
            ob1.observe(elemA);
        }
    }, []);

    // 添加到日历
    const addHandle = async () => {
        const res = await calendarCreate(locale, {
            location: locale,
            startTime: '2024-06-24 19:00:00', //2024年6月24日 19:00（PST）
            endTime: '2024-06-24 19:00:00',
            summary: 'EcoFlow DELTA Pro 3 Live Launch',
        });
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_button',
            page_name: 'delta-pro-3-portable-power-station',
            list_name: t('Livestream.title'),
            button_name: t('Livestream.btn'),
            function: 'Add Calendar',
        });
    };

    // const iframeOnload = () => {
    //     setIsShow2(true);
    // };

    const handlePlay = () => {
        setIsShow2(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow DELTA Pro 3 | Teasing now',
            position: 'Product Preview_7',
        });
    };

    return (
        <div id={locale !== 'au' ? 'dp3-teaser-K' : ''} className={`${css.thecomp} dp3-module-box dp3-teaser-K`}>
            <div className="dp3-inter">
                <h2 className="dp3-title left Livestream-title">{t('Livestream.title')}</h2>
                {locale !== 'au' && <p className="Livestream-desc">{t('Livestream.desc')}</p>}
                {locale !== 'au' && (
                    <div className="Livestream-btn-line">
                        <button className="dp3-btn" onClick={addHandle}>
                            {t('Livestream.btn')}
                        </button>
                    </div>
                )}
                <div className={`Livestream-img-box${isShow2 ? ' is-youtube' : ''}`}>
                    <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1715222572467/DP3-Teaser-KV.png" />
                    <div className="Livestream-icon" onClick={handlePlay}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="81" viewBox="0 0 80 81" fill="none">
                            <path
                                d="M75.1349 21.7864C74.739 20.2044 73.9325 18.755 72.7971 17.5844C71.6617 16.4139 70.2374 15.5637 68.6683 15.1197C62.9349 13.7197 40.0016 13.7197 40.0016 13.7197C40.0016 13.7197 17.0682 13.7197 11.3349 15.2531C9.76574 15.697 8.34151 16.5472 7.20607 17.7177C6.07063 18.8883 5.26421 20.3378 4.86825 21.9197C3.81896 27.7382 3.3057 33.6408 3.33491 39.5531C3.29751 45.5099 3.81081 51.4574 4.86825 57.3197C5.30478 58.8526 6.12927 60.2469 7.26206 61.368C8.39485 62.4891 9.79765 63.2991 11.3349 63.7197C17.0682 65.2531 40.0016 65.2531 40.0016 65.2531C40.0016 65.2531 62.9349 65.2531 68.6683 63.7197C70.2374 63.2758 71.6617 62.4256 72.7971 61.255C73.9325 60.0845 74.739 58.635 75.1349 57.0531C76.1761 51.2784 76.6893 45.4208 76.6683 39.5531C76.7057 33.5962 76.1924 27.6487 75.1349 21.7864Z"
                                fill="#FF0200"
                            />
                            <path d="M32.5 50.4533L51.6667 39.5533L32.5 28.6533V50.4533Z" fill="white" />
                        </svg>
                    </div>
                    {isShow2 && <iframe id="youtube-iframe" className="youtube-iframe" src={locale === 'au' ? SOURCE_AU : url1}></iframe>}
                </div>
            </div>
        </div>
    );
};

export default TheComp;
